import { DownTrendIcon } from "@/app/icons/down-trend"
import { UpTrendIcon } from "@/app/icons/up-trend"
import { cn } from "@rarible_int/anaconda_ui_components"
import { formatPercentage } from "../../../percentage/utils"
import { Percentage } from "./percentage"

export type Trend = "up" | "down" | "neutral"

interface Props {
  changePercent: number
  TrendDisplay?: React.ComponentType<{ trend: Trend }>
  className?: string
}

function TrendIcon(props: { trend: Trend }) {
  if (props.trend === "neutral") return null

  return props.trend === "up" ? <UpTrendIcon /> : <DownTrendIcon />
}

export function ChangeTrend({
  changePercent,
  TrendDisplay = TrendIcon,
  className,
}: Props) {
  const formattedPercentage = formatPercentage(changePercent)
  const trend = useTrend(formattedPercentage)

  return (
    <div
      className={cn(
        "flex items-center gap-1.5",
        {
          "text-success": formattedPercentage > 0,
          "text-destructive": formattedPercentage < 0,
          "text-muted-foreground": formattedPercentage === 0,
        },
        className,
      )}
    >
      <TrendDisplay trend={trend} />
      <Percentage value={Math.abs(changePercent)} />
    </div>
  )
}

const useTrend = (changePercent: number) => {
  if (changePercent > 0) return "up"
  if (changePercent < 0) return "down"

  return "neutral"
}
